/* istanbul ignore file */
import raw from 'raw.macro';
const html = raw('./html.ejs');

export default { html };
